import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = { recipeId: Number }

  connect() {
    this.checked = new Set(this.load())
    this.itemTargets.forEach((el) => this.render(el))
  }

  toggle(event) {
    const item = event.currentTarget
    const id = item.dataset.ingredientId
    if (this.checked.has(id)) {
      this.checked.delete(id)
    } else {
      this.checked.add(id)
    }
    this.render(item)
    this.save()
  }

  // Reset every checked-off ingredient.
  clear() {
    this.checked.clear()
    this.itemTargets.forEach((el) => this.render(el))
    this.save()
  }

  render(el) {
    const id = el.dataset.ingredientId
    el.classList.toggle("line-through", this.checked.has(id))
    el.classList.toggle("opacity-40", this.checked.has(id))
  }

  load() {
    try {
      return JSON.parse(localStorage.getItem(this.key)) || []
    } catch { return [] }
  }

  save() {
    localStorage.setItem(this.key, JSON.stringify([...this.checked]))
  }

  get key() {
    return `recidex-checked-${this.recipeIdValue}`
  }
}
